import React, { useContext } from 'react';
import ProfileDropdown from '../ProfileDropdown';
import SearchBar from '../SearchBar';
import NavigationLogo from '../NavigationLogo';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { StoreContext } from '../lib/Store';
import { boards } from '../utils/constants';

const Header = ({ appName, slogan, logoUrl }) => {
  const { state } = useContext(StoreContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname === '/') {
      const sensor = searchParams.get('sensor');
      const board = searchParams.get('board');
      const boardList = [boards.C3_MINI, boards.D1_MINI, boards.ESP32_MINI];
      if (!!sensor && !!board && board in boardList) {
        const result = state.data.binaries.filter(
          (_binary, i) => _binary.id === sensor
        );

        if (result.length > 0) {
          const path = `/${sensor}/${board}`;
          navigate(path, { replace: false });
        }
      }
    }
  }, []);

  return (
    <header id='header' className='header fixed-top d-flex align-items-center'>
      <NavigationLogo appName={appName} logoUrl={logoUrl} />
      {/* <!-- End Logo --> */}

      <SearchBar />
      {/* <!-- End Search Bar --> */}

      <nav className='header-nav ms-auto'>
        <ul className='d-flex align-items-center'>
          <li className='nav-item d-block d-lg-none'>
            <a className='nav-link nav-icon search-bar-toggle ' href='#'>
              <i className='bi bi-search'></i>
            </a>
          </li>
          {/* <!-- End Search Icon--> */}

          <li className='nav-item dropdown pe-3'>
            <ProfileDropdown
              appName={appName}
              logoUrl={logoUrl}
              slogan={slogan}
            />
            {/* <!-- End Profile Dropdown Items --> */}
          </li>
          {/* <!-- End Profile Nav --> */}
        </ul>
      </nav>
      {/* <!-- End Icons Navigation --> */}
    </header>
  );
};

export default Header;
